"use client";

import CommenDialog from "../tbs-sender/components/dialogbox";
import PreviewStep from "../tbs-sender/components/PreviewStep";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../components/loader";
import { APIGetTBSDetails } from "../../../service/api-service";
import { GetTBSDetailsResEntity } from "../../../interface/tbs-tracker/send-tbs";
export default function VerifyTBSItem() {
    const navigate = useNavigate();
    const tbsId = useParams().id;
    const [isLoading, setIsLoading] = useState(false);
    const [tbsData, setTbsData] = useState<GetTBSDetailsResEntity | null>(null);
    const [showSuccessDialog, setShowSuccessDialog] = useState<boolean>(false)
    const [tbsNumber, setTbsNumber] = useState<string>("");
    const handleBack = () => {
        navigate(-1);
    };

    const handleSubmit = (tbsNumber: string) => {
        setTbsNumber(tbsNumber);
        setShowSuccessDialog(true);
        console.log("Verify Submitted");
    };
    const fetchTBSDetails = async () => {
        if (!tbsId) return;

        setIsLoading(true);

        try {
            const resp = await APIGetTBSDetails(tbsId);
            if (
                resp &&
                resp.data &&
                (resp.status === 200)
            ) {
                const apiResp = resp.data;

                if (apiResp && apiResp.statusCode === 200 && apiResp.data) {
                    setTbsData(apiResp.data);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!tbsId) {
            navigate(-1);
            return;
        }

        fetchTBSDetails();
    }, [tbsId]);

    if (isLoading || !tbsData) {
        return <Loader isLoading={true} />;
    }

    return (
        <>
            <div className="content-wrapper">
                <PreviewStep
                    previewData={tbsData}
                    onBack={handleBack}
                    onSubmit={handleSubmit}
                    isVerify={true}
                />
            </div>
            <CommenDialog
                isOpen={showSuccessDialog}
                title="TBS items verified Successfully!"
                description={
                    <>
                        Tracker <strong>#{tbsNumber}</strong> has been verified at store.
                    </>
                }
                buttonText="Close"
                onClose={() => {
                    setShowSuccessDialog(false);
                    navigate(-1);
                }}
            />
        </>
    );
}